import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { ABOUT } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-20 md:py-32 bg-ivory overflow-hidden scroll-mt-20">
    <span aria-hidden="true" className="pointer-events-none select-none absolute -top-8 right-0 font-serif italic text-[22vw] leading-none text-royal/[0.04]">
      Legacy
    </span>
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <Reveal className="md:col-span-5 relative">
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-full h-full border border-gold/40 rounded-sm" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-sm">
              <img
                src={ABOUT.image}
                alt={ABOUT.alt}
                loading="lazy"
                className="w-full h-[420px] md:h-[560px] object-cover transition-transform duration-[800ms] ease-out hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-7 -right-4 md:-right-7 bg-royal text-ivory px-7 py-5 rounded-sm shadow-[0_10px_40px_rgba(6,48,35,0.25)]">
              <p className="font-serif italic text-2xl text-gold-light">Since generations</p>
              <p className="text-[11px] tracking-[0.25em] uppercase text-ivory/60 mt-1">Howrah, West Bengal</p>
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-7 md:pl-6">
          <SectionHeading chapter="01" overline="About Us" title={ABOUT.title} />
          <div className="space-y-5 -mt-6 md:-mt-10">
            {ABOUT.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.08 * i}>
                <p className={`leading-relaxed ${i === 0 ? "font-serif text-xl md:text-2xl text-royal-deep/90" : "text-base md:text-lg font-light text-charcoal/70"}`}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.35}>
            <button
              data-testid="about-discover-story-button"
              onClick={() => scrollToId("directors")}
              className="mt-9 px-7 py-3.5 border border-gold text-gold-muted text-sm tracking-[0.12em] uppercase font-medium rounded-sm hover:bg-gold hover:text-royal-deep transition-colors duration-300"
            >
              Discover Our Story
            </button>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
